module.exports = __webpack_public_path__ + "img/Covid-19.bd3a53ad.jpg";